module.exports = __webpack_public_path__ + "static/faraday-maxwell-and-the-electromagnetic-field-09472cd719e8d02868e0bb1d84b98804.jpg";